// src/components/UserBadge.jsx
import React, { useMemo } from 'react';
import { FaCheckCircle, FaCrown, FaTrophy, FaShieldAlt } from 'react-icons/fa';
import './UserBadge.css';

// 7.4 : Ordre de priorité (Vérification > Rôle > Accomplissement)
const PRIORITY_CATEGORIES = ['verification', 'role', 'accomplishment'];

const UserBadge = ({ badge, size = 'md', animate = true }) => {
    // Si pas de badge, on n'affiche rien
    if (!badge) return null;

    // Déterminer l'icône et la couleur (7.2 : paramétrable par l'admin)
    const icon = badge.icon || 'faCheckCircle';
    const color = badge.color || '#3b82f6';

    // 🆕 Tooltip dynamique (7.2 : "Compte vérifié par INSULATED")
    const tooltipText = badge.category === 'verification' 
        ? 'Compte vérifié par INSULATED' 
        : badge.label || 'Badge';

    // 7.5 : Accessibilité - on désactive l'animation si l'utilisateur préfère réduire les mouvements
    const shouldAnimate = animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    return (
        <div 
            className={`user-badge user-badge-${size} ${shouldAnimate ? 'user-badge-animated' : ''}`}
            style={{ color: color }}
            title={tooltipText}
        >
            <FaCheckCircle />
        </div>
    );
};

export default UserBadge;